import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { Looks5Rounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { BasementWallInput } from '@core/const'
import { BasementWallResponse } from '@/core/query'

export interface BasementWallHistory extends BasementWallInput {
  type: 'BasementWall',
  result: BasementWallResponse
}

interface Props {
  history: BasementWallHistory
}
function BasementWallHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <Looks5Rounded />
        <Box className="grid grid-cols-2 gap-8 min-w-[15rem] overflow-auto">
          {history.b1Height > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B1_FLOOR_HEIGHT')}
              unit="m"
              value={history.b1Height}
            />
          )}
          {history.b2Height > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B2_FLOOR_HEIGHT')}
              unit="m"
              value={history.b2Height}
            />
          )}
          {history.b3Height > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B3_FLOOR_HEIGHT')}
              unit="m"
              value={history.b3Height}
            />
          )}
          {history.b4Height > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B4_FLOOR_HEIGHT')}
              unit="m"
              value={history.b4Height}
            />
          )}
          {history.b5Height > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B5_FLOOR_HEIGHT')}
              unit="m"
              value={history.b5Height}
            />
          )}
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <Box className="grid grid-cols-2 gap-8 min-w-[15rem] overflow-auto">
          {history.result.thickness[0] > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B1_FLOOR_THICKNESS')}
              unit="mm"
              value={history.result.thickness[0]}
            />
          )}
          {history.result.thickness[1] > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B2_FLOOR_THICKNESS')}
              unit="mm"
              value={history.result.thickness[1]}
            />
          )}
          {history.result.thickness[2] > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B3_FLOOR_THICKNESS')}
              unit="mm"
              value={history.result.thickness[2]}
            />
          )}
          {history.result.thickness[3] > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B4_FLOOR_THICKNESS')}
              unit="mm"
              value={history.result.thickness[3]}
            />
          )}
          {history.result.thickness[4] > 0 && (
            <HistoryItemField
              label={t('GLOSSARY.B5_FLOOR_THICKNESS')}
              unit="mm"
              value={history.result.thickness[4]}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default BasementWallHistoryItem
